import React, { useContext, useEffect } from 'react';
import { Box, useTheme } from '@mui/material';
import ReactDOM from 'react-dom';
import MapContext, { MapContextType } from '@/context/MapContext/MapContext';

interface SwipeLineControlProps {
  swipeValue: number; // (0–100)
}

const SAFE_MARGIN = 20; // px

const classnamesMoveSmall = ['ol-scale-line', 'sidebar', 'ol-coord-zoom-status'];
const classnamesMoveLarge = ['ol-scale-ratio', 'ol-status-control'];

const modifyClasses = (classnameArray: string[], offsetClass: string, action: 'add' | 'remove') => {
  classnameArray.forEach((cls) => {
    document.querySelectorAll(`.${cls}`).forEach((el) => {
      if (action === 'add') el.classList.add(offsetClass);
      else el.classList.remove(offsetClass);
    });
  });
};

const SwipeLine = ({ swipeValue }: SwipeLineControlProps) => {
  const { map } = useContext(MapContext) as MapContextType;
  const theme = useTheme();

  // container can change over time → track it in state
  const container = map?.getTargetElement();

  useEffect(() => {
    if (!map) return undefined;

    modifyClasses(classnamesMoveSmall, "swipe-offset-small", "add");
    modifyClasses(classnamesMoveLarge, "swipe-offset-large", "add");

    return () => {
      modifyClasses(classnamesMoveSmall, "swipe-offset-small", "remove");
      modifyClasses(classnamesMoveLarge, "swipe-offset-large", "remove");
    };
  }, [map]);

  if (!map || !container) return null;

  return ReactDOM.createPortal(
    <Box
      sx={{
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        left: SAFE_MARGIN,
        right: SAFE_MARGIN,
        height: "100%",
      }}
    >
      <div
        style={{
          position: "relative",
          top: 0,
          left: `${swipeValue / 10}%`,
          height: "100%",
          width: "8px",
          backgroundColor: `${theme.palette.primary.light}66`,
          border: "1px solid white",
          transform: "translateX(-50%)",
        }}
      />
    </Box>,
    container
  );
};

export default SwipeLine;
